import { render, staticRenderFns } from "./HeartbeatsTab.vue?vue&type=template&id=2e9daa65&scoped=true&"
import script from "./HeartbeatsTab.vue?vue&type=script&lang=ts&"
export * from "./HeartbeatsTab.vue?vue&type=script&lang=ts&"
import style0 from "./HeartbeatsTab.vue?vue&type=style&index=0&id=2e9daa65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9daa65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VProgressLinear})
